import { call, put, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/integrations';
import api from '~/services/api';

function* loadIntegrations({ partner }) {
  try {
    const res = yield call(api.get, `/v2/partners/${partner}/integrations`);
    const { need_attention, syncronized_at } = res.data || {};

    if (syncronized_at) {
      yield put(
        actions.loadIntegrationsSuccess(need_attention, syncronized_at)
      );
    }
  } catch (e) {}
}

const sagas = [takeLatest(Types.LOAD_INTEGRATIONS, loadIntegrations)];

export default sagas;
